@let items = items$() | async;
@let totalNumber = total();
@let finland = getFinland();

@if (isMobile()) {
  <ng-template #mobileFilterContent>
    <div class="pr-large">
      <fin-expand [id]="'destinations-mobile'" [key]="'destinations-mobile'" #expand>
        <div class="trigger flex flex--space-between border-top border-bottom ps-small bold-type">
          <span class="flex flex--center g-small">
            {{ 'blueWingsSEO.tags.destinations' | finLocalization }}
            @if (activeCountryCount() > 0) {
              <span class="flex--inline flex--center active-count">{{ activeCountryCount() }}</span>
            }
          </span>
          <fcom-icon
            class="rotate icon-medium"
            [ngClass]="{ 'rotate-active': expand.isOpen$ | async }"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
        <div class="content filter-list flex flex--column relative">
          <div class="filter-list__container ps-small-t ps-small-x">
            <div class="filter-list__continents flex g-small ps-small-b">
              @if (finland) {
                <fcom-chip
                  [title]="('actions.select' | finLocalization) + ' ' + ('blueWingsSEO.countries.fi' | finLocalization)"
                  [text]="'blueWingsSEO.countries.fi' | finLocalization"
                  [theme]="finland.isActive ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
                  (tagClicked)="
                    updateFiltersList(
                      COUNTRY_CODE.FI,
                      BluewingsFilterType.DESTINATIONS,
                      BluewingsFilterTypeContinent.EUROPE
                    )
                  "
                ></fcom-chip>
              }
              @for (continent of continents(); track $index) {
                <fcom-chip
                  [ngClass]="{ hasFilter: onContinentSelection(continent.value) }"
                  [title]="('actions.select' | finLocalization) + ' ' + continent.name"
                  [text]="continent.name"
                  [theme]="activeContinent() === continent.value ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
                  (tagClicked)="showContinents(continent.value)"
                ></fcom-chip>
              }
            </div>

            <ng-container *ngTemplateOutlet="continentList" />
          </div>
        </div>
      </fin-expand>

      <ng-container
        *ngTemplateOutlet="
          mobileSubjectFilter;
          context: {
            subject: worldOfFinnairFilterType(),
            list: subjects(),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          mobileSubjectFilter;
          context: {
            subject: BluewingsFilterType.TRAVEL_EXPERIENCE,
            list: subjects(),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          mobileSubjectFilter;
          context: {
            subject: BluewingsFilterType.TRAVEL_TIPS,
            list: subjects(),
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          mobileSubjectFilter;
          context: {
            subject: BluewingsFilterType.SEASONALITY,
            list: subjects(),
          }
        "
      ></ng-container>
    </div>
  </ng-template>
  <fcom-filters
    data-testid="'bluewings-filters-mobile'"
    [buttonText]="'blueWingsSEO.mobileFilterText' | finLocalization"
    [hasFiltering]="hasFiltering()"
    [isModalOpen]="isModalOpen()"
    [modalTitle]="'blueWingsSEO.modalTitle' | finLocalization"
    [numberToShowWhenFiltered]="hasFiltering() ? activeCountryCount() + countActive() : 0"
    [primaryFooterButtonTitle]="'blueWingsSEO.applyFilters' | finLocalization"
    [secondaryFooterButtonTitle]="'blueWingsSEO.clearFilters' | finLocalization"
    [filterContent]="mobileFilterContent"
    (filtersClose)="closeModal()"
    (primaryFooterButtonClick)="applyFiltersAndClose(BluewingsFilterType.DESTINATIONS, true)"
    (secondaryFooterButtonClick)="clearAllFilters()"
    (filtersOpen)="showModal()"
  ></fcom-filters>
} @else {
  <div class="filters-container flex flex--wrap g-medium ps-medium-b fill">
    <ng-template #desktopDestinationsFilterContent>
      <div class="filter-list flex flex--column relative">
        <div class="filter-list__container ps-small-t ps-small-x">
          <div class="flex flex--wrap g-small ps-small-b">
            @if (finland) {
              <fcom-chip
                [title]="('actions.select' | finLocalization) + ' ' + ('blueWingsSEO.countries.fi' | finLocalization)"
                [text]="'blueWingsSEO.countries.fi' | finLocalization"
                [theme]="finland.isActive ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
                (tagClicked)="
                  updateFiltersList(
                    COUNTRY_CODE.FI,
                    BluewingsFilterType.DESTINATIONS,
                    BluewingsFilterTypeContinent.EUROPE
                  )
                "
              ></fcom-chip>
            }
            @for (continent of continents(); track $index) {
              <fcom-chip
                [ngClass]="{ hasFilter: onContinentSelection(continent.value) }"
                [title]="('actions.select' | finLocalization) + ' ' + continent.name"
                [text]="continent.name"
                [theme]="activeContinent() === continent.value ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
                (tagClicked)="showContinents(continent.value)"
              ></fcom-chip>
            }
          </div>

          <ng-container *ngTemplateOutlet="continentList" />
        </div>
      </div>
    </ng-template>
    <fcom-filters
      [ngClass]="{ hasFilter: countActiveCountries(false) }"
      [dropdownVisual]="true"
      [hasFiltering]="!!countActiveCountries(false)"
      [buttonText]="'blueWingsSEO.tags.destinations' | finLocalization"
      [modalTitle]="'blueWingsSEO.tags.destinations' | finLocalization"
      [isModalOpen]="activeDesktopFilter() === BluewingsFilterType.DESTINATIONS"
      [primaryFooterButtonTitle]="'blueWingsSEO.applyFilters' | finLocalization"
      [secondaryFooterButtonTitle]="'blueWingsSEO.clearFilters' | finLocalization"
      [filterContent]="desktopDestinationsFilterContent"
      (filtersOpen)="activeDesktopFilter.set(BluewingsFilterType.DESTINATIONS)"
      (filtersClose)="activeDesktopFilter.set(null)"
      (primaryFooterButtonClick)="applyFiltersAndClose(BluewingsFilterType.DESTINATIONS)"
      (secondaryFooterButtonClick)="clearFilter(BluewingsFilterType.DESTINATIONS)"
    ></fcom-filters>

    <ng-container
      *ngTemplateOutlet="
        subjectFilter;
        context: {
          subject: worldOfFinnairFilterType(),
          list: subjects(),
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        subjectFilter;
        context: {
          subject: BluewingsFilterType.TRAVEL_EXPERIENCE,
          list: subjects(),
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        subjectFilter;
        context: {
          subject: BluewingsFilterType.TRAVEL_TIPS,
          list: subjects(),
        }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        subjectFilter;
        context: {
          subject: BluewingsFilterType.SEASONALITY,
          list: subjects(),
        }
      "
    ></ng-container>
  </div>
}

<ng-template #subjectFilter let-subject="subject" let-list="list">
  <ng-template #subjectFilterContent>
    <div [id]="'list-' + subject" class="filters-popover flex flex--wrap g-small ps-medium-x ps-xsmall-t ps-large-b">
      @for (item of list; track $index) {
        @if (item.type === subject) {
          <fcom-chip
            [attr.data-testid]="'tag-' + item.value"
            [text]="item.name"
            [theme]="item.isActive ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
            (tagClicked)="updateFiltersList(item.value, subject)"
          />
        }
      }
    </div>
  </ng-template>
  <fcom-filters
    [ngClass]="{ hasFilter: countActive(subject) > 0 }"
    [buttonText]="'blueWingsSEO.tags.' + subject | finLocalization"
    [dropdownVisual]="true"
    [hasFiltering]="countActive(subject) > 0"
    [modalTitle]="'blueWingsSEO.tags.' + subject | finLocalization"
    [isModalOpen]="activeDesktopFilter() === subject"
    [primaryFooterButtonTitle]="'blueWingsSEO.applyFilters' | finLocalization"
    [secondaryFooterButtonTitle]="'blueWingsSEO.clearFilters' | finLocalization"
    [filterContent]="subjectFilterContent"
    (filtersOpen)="activeDesktopFilter.set(subject)"
    (filtersClose)="activeDesktopFilter.set(null)"
    (primaryFooterButtonClick)="applyFiltersAndClose(subject)"
    (secondaryFooterButtonClick)="clearFilter(subject)"
  ></fcom-filters>
</ng-template>

<ng-template #mobileSubjectFilter let-subject="subject" let-list="list">
  <fin-expand [id]="subject" [key]="subject" #expand>
    <div class="trigger flex flex--space-between border-bottom ps-small bold-type">
      <span class="flex flex--center g-small">
        {{ 'blueWingsSEO.tags.' + subject | finLocalization }}
        @if (countActive(subject) > 0) {
          <span class="flex--inline flex--center active-count">{{ countActive(subject) }}</span>
        }
      </span>
      <fcom-icon
        class="rotate icon-medium"
        [ngClass]="{ 'rotate-active': expand.isOpen$ | async }"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      />
    </div>
    <div [id]="'list-' + subject" class="content filters-popover flex flex--wrap g-small pr-medium-x pr-large-y">
      @for (item of list; track $index) {
        @if (item.type === subject) {
          <fcom-chip
            [attr.data-testid]="'tag-' + item.value"
            [text]="item.name"
            [theme]="item.isActive ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
            (tagClicked)="updateFiltersList(item.value, subject)"
          />
        }
      }
    </div>
  </fin-expand>
</ng-template>

@if (!isMobile()) {
  <div
    class="flex flex--wrap g-small ms-large-y"
    [ngClass]="{
      'pr-medium-b border-bottom nordic-blue-100-border border-primary': !isMobile(),
    }"
  >
    @for (filter of activeFilters(); track $index) {
      <fcom-button
        [id]="filter.value"
        [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE, position: IconPosition.RIGHT }"
        [text]="filter.name"
        (clickBtn)="removeFilter(filter.value, filter.type, filter.continent ? filter.continent : null)"
      ></fcom-button>
    }
    @if (activeFilters().length > 1) {
      <fcom-button
        (clickBtn)="clearAllFilters()"
        [text]="'blueWingsSEO.clearAllFilters' | finLocalization"
        [icon]="{ name: SvgLibraryIcon.TRASH, position: IconPosition.LEFT }"
        [theme]="ButtonTheme.TERTIARY_GHOST"
      />
    }
  </div>
}

<p class="bold-type ms-large-b" [ngClass]="{ 'ms-large-t': isMobile() }">
  @if (itemsLoader() && itemsLoadingStatus() === ItemStatus.INITIAL_LOAD) {
    <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT" />
    <span [innerHTML]="'blueWingsSEO.articlePlural' | finLocalization: { count: '' }"></span>
  } @else {
    <span
      [innerHTML]="
        totalNumber === 1
          ? ('blueWingsSEO.articleSingular' | finLocalization: { count: totalNumber })
          : ('blueWingsSEO.articlePlural' | finLocalization: { count: totalNumber })
      "
    ></span>
  }
</p>

<ng-template #continentList>
  @for (item of continents(); track $index) {
    @if (activeContinent() === item.value) {
      <ul class="filter-list__items flex flex--column g-small ms-small-b ps-xsmall" [id]="'list-' + item.value">
        @for (country of destinations(); track country.value) {
          @if (country.continent === item.value && country.value !== COUNTRY_CODE.FI) {
            <li>
              <fcom-button
                class="fill"
                [mode]="ButtonMode.FILL"
                [id]="country.value"
                [icon]="{
                  name: country.isActive ? SvgLibraryIcon.CHECKBOX_SELECTED : SvgLibraryIcon.CHECKBOX_UNSELECTED,
                  position: IconPosition.LEFT,
                }"
                [text]="country.name"
                [theme]="ButtonTheme.TERTIARY_GHOST"
                (clickBtn)="updateFiltersList(country.value, BluewingsFilterType.DESTINATIONS, country.continent)"
              />
            </li>
          }
        }
      </ul>
    }
  }
</ng-template>

@if (items) {
  <div class="search-api-list grid-col-12 no-gutters">
    @for (item of items; track item) {
      <fin-teaser-card
        #listItem
        class="col-1-12 card-wrapper grid-third"
        [aspectRatio]="AspectRatio"
        [content]="item"
        [attr.lang]="item.contentLocale"
      />
    }

    @for (item of loadedItems(); track item) {
      <fin-teaser-card
        #listItem
        class="col-1-12 card-wrapper grid-third"
        [aspectRatio]="AspectRatio"
        [content]="item"
        [attr.lang]="item.contentLocale"
      />
    }
  </div>
}

@if (
  itemsLoadingStatus() === ItemStatus.LOADING || (!nextPageLink() && itemsLoadingStatus() === ItemStatus.LOAD_MORE)
) {
  <div class="flex flex--column col-1-12">
    <fcom-loader [loaderType]="LoaderTheme.EMBEDDED" />
  </div>
}

@if (itemsLoadingStatus() === ItemStatus.EMPTY) {
  <p>{{ 'blueWingsSEO.noResult' | finLocalization }}</p>
}

@if (nextPageLink() && itemsLoadingStatus() !== ItemStatus.LOADING) {
  <fcom-button
    data-testid="load-more-articles"
    class="mr-medium-t"
    [aria]="{
      loadingLabel: 'actions.loading' | finLocalization,
      label:
        'blueWingsSEO.accessibility.loadMore' | finLocalization: { page: pageNumber() + 1, total: numberOfPages() },
    }"
    [href]="nextPageLink()"
    [loading]="itemsLoader()"
    [text]="'actions.loadMore' | finLocalization"
    [theme]="ButtonTheme.SECONDARY_OUTLINE"
    (clickBtn)="loadMore($event)"
  />
}

@if (pageNumber() === numberOfPages()) {
  <p class="is-vishidden" aria-live="polite">{{ 'blueWingsSEO.accessibility.endOfList' | finLocalization }}</p>
}
